import React from 'react';

import ReactDOM from 'react-dom/client';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import translations from './translations';
import reportWebVitals from './reportWebVitals';

i18next.use(LanguageDetector).init(translations).then();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    /* <React.StrictMode> */
    <I18nextProvider i18n={i18next}>
        <App />
    </I18nextProvider>
    /* </React.StrictMode> */
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
